import type { InvoiceDateType, InvoiceStatus } from "@shared/types";

export interface InvoiceFilters {
  query?: string;
  status?: InvoiceStatus[];
  dateFrom?: string;
  dateTo?: string;
  dateType?: InvoiceDateType;
  country?: string[];
  crossBorderOnly?: boolean;
}

// Helper function for status badge variants
export const getStatusBadgeVariant = (status: InvoiceStatus) => {
  switch (status) {
    case "Paid":
      return "default";
    case "Unpaid":
      return "secondary";
    case "Cancelled":
      return "outline";
    case "Unposted":
      return "outline";
    default:
      return "secondary";
  }
};
